import { TRANSLATIONS } from './translations';

export interface IInfoPageContent {
  titleKey: string;
  bodyKeys: string[];
}

/**
 * Placeholder content pages linked from SiteFooter (help center, safety,
 * host resources, about us, etc.) -- template copy, not real legal text.
 * Keyed by the slug used in the /info/:slug route.
 */
export const INFO_PAGES: Record<string, IInfoPageContent> = {
  'help-center': {
    titleKey: TRANSLATIONS.INFO_HELP_CENTER_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_HELP_CENTER_BODY_1, TRANSLATIONS.INFO_HELP_CENTER_BODY_2],
  },
  safety: {
    titleKey: TRANSLATIONS.INFO_SAFETY_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_SAFETY_BODY_1, TRANSLATIONS.INFO_SAFETY_BODY_2],
  },
  'cancellation-options': {
    titleKey: TRANSLATIONS.INFO_CANCELLATION_OPTIONS_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_CANCELLATION_OPTIONS_BODY_1, TRANSLATIONS.INFO_CANCELLATION_OPTIONS_BODY_2],
  },
  contact: {
    titleKey: TRANSLATIONS.INFO_CONTACT_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_CONTACT_BODY_1, TRANSLATIONS.INFO_CONTACT_BODY_2],
  },
  'host-resources': {
    titleKey: TRANSLATIONS.INFO_HOST_RESOURCES_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_HOST_RESOURCES_BODY_1, TRANSLATIONS.INFO_HOST_RESOURCES_BODY_2],
  },
  'host-community': {
    titleKey: TRANSLATIONS.INFO_HOST_COMMUNITY_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_HOST_COMMUNITY_BODY_1, TRANSLATIONS.INFO_HOST_COMMUNITY_BODY_2],
  },
  'host-liability': {
    titleKey: TRANSLATIONS.INFO_HOST_LIABILITY_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_HOST_LIABILITY_BODY_1, TRANSLATIONS.INFO_HOST_LIABILITY_BODY_2],
  },
  about: {
    titleKey: TRANSLATIONS.INFO_ABOUT_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_ABOUT_BODY_1, TRANSLATIONS.INFO_ABOUT_BODY_2],
  },
  'how-it-works': {
    titleKey: TRANSLATIONS.INFO_HOW_IT_WORKS_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_HOW_IT_WORKS_BODY_1, TRANSLATIONS.INFO_HOW_IT_WORKS_BODY_2],
  },
  careers: {
    titleKey: TRANSLATIONS.INFO_CAREERS_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_CAREERS_BODY_1, TRANSLATIONS.INFO_CAREERS_BODY_2],
  },
  press: {
    titleKey: TRANSLATIONS.INFO_PRESS_TITLE,
    bodyKeys: [TRANSLATIONS.INFO_PRESS_BODY_1, TRANSLATIONS.INFO_PRESS_BODY_2],
  },
};
